// glode-home-init.js — script in pagina di prototipo/premium/index.html (P26).
// Unica modifica: rimossa la chiamata a montaTelaio(), che nel tema monterebbe un secondo
// telaio sopra quello di Horizon. Tutto il resto è identico all'originale.
// autoplay hero video (B.11): il muted da markup clonato da <template> può non riflettersi
// nella proprietà IDL su Chromium → belt-and-braces
document.querySelectorAll('video[muted]').forEach(v => { v.muted = true; v.play().catch(() => {}); });
montaTiles('#griglia-amati', POPOLARI);
montaTutti('#griglia-tutti');
const rec = [];
for (const pr of P) for (const r of pr.recensioni) rec.push({ ...r, prodotto: pr.nome });
const grande = rec.find(r => r.testo.length > 80) || rec[0];
document.getElementById('quote-grande').textContent = '«' + grande.testo + '»';
document.getElementById('quote-autore').textContent = `${grande.autore}, ${grande.eta} anni — ${grande.prodotto}`;
document.getElementById('recensioni-fila').innerHTML = rec.filter(r => r !== grande).slice(0, 3).map(r =>
  `<div class="recensione"><span class="stelle">★★★★★</span><p>${r.testo}</p><cite>${r.autore}, ${r.eta} — ${r.prodotto}</cite></div>`).join('');
